import TeamMembers from "features/teams/TeamMembers";

const TeamMembersPage = () => {
  return <TeamMembers />;
};

export default TeamMembersPage;
